import btnX from '../../icon/x_button_bg.svg';
import Modal from 'react-modal';
import { onToggleModal } from '../../utils/utils';

export const ResponsiveConfirmModal = ({ width, padding = 'p-[32px]', title, content, setIsOpen, onClose, onConfirm, type }) => {
  return (
    <Modal
      isOpen={() => onToggleModal(setIsOpen)}
      shouldCloseOnOverlayClick={false}
      className={`bg-white rounded-[8px] mx-4 ${width} max-w-[calc(100vw-32px)]`}
      style={{
        overlay: {
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '16px',
        },
        content: {
          position: 'static',
          maxWidth: '100%',
          maxHeight: '90vh',
          overflow: 'auto',
          width: '100%',
        },
      }}
    >
      <div className="w-full flex justify-end px-3 py-3">
        <button onClick={() => onToggleModal(setIsOpen)}>
          <img src={btnX} className="w-6 h-6 md:w-auto md:h-auto" />
        </button>
      </div>
      <div className={`${padding}`}>
        <div className="flex justify-center mb-[4px]">
          <p className="text-[18px] md:text-[24px] font-[450] text-center px-4">{title}</p>
        </div>
        <div className="mb-[20px] text-center font-[400] px-4">{content}</div>
        <div className="flex justify-center">
          {type === 'complete' ? (
            <button
              className="px-6 md:px-8 py-2 rounded-xl bg-[#36B37E] text-white text-[16px] leading-6 font-[350]"
              onClick={onClose}
            >
              확인
            </button>
          ) : (
            <button
              className="px-6 md:px-8 py-2 rounded-xl bg-[#CE3426] text-white text-[16px] leading-6 font-[350]"
              onClick={onConfirm}
            >
              삭제
            </button>
          )}
        </div>
      </div>
    </Modal>
  );
};

export default ResponsiveConfirmModal;